import baseConfig from '../config.js';
import basicFormHelper from '../basic.form.helper.js';
import {regular} from '../validate.js.js';

//注明：如果列表中需要有编码，配置initCodeRules，则会自动加载XXDesc,XXCodeItems(XX表示数据项的属性名)
const columns: any = [
    {
        dataIndex: 'serialNumber',
        title: '序号',
        width: '60px',
        scopedSlots: {
            //插槽相关customRender的值对应slot，slot-scope可以得到text,record
            customRender: 'serialNumber'
        }
    },
    {
        dataIndex: 'nickname',
        title: '姓名',
        width: '120px',
        ellipsis: true,
        scopedSlots: {
            customRender: 'nickname'
        }
    },
    {
        title: '性别',
        dataIndex: 'sex',
        width: '60px',
        customRender: (text: Number) => {
            if (text === 0) return '女';
            if (text === 1) return '男';
            return '未知';
        }
    },
    {
        dataIndex: 'username',
        title: '账号',
        width: '210px',
        ellipsis: true,
        scopedSlots: {
            customRender: 'teacherAccount'
        }
    },
    {
        title: '授课班级与课程',
        scopedSlots: {
            customRender: 'classAndCourse'
        },
        width: '130px',
        ellipsis: true
    },
    {
        title: '账号有效期',
        scopedSlots: {
            customRender: 'usefulLife'
        },
        width: '190px',
        ellipsis: true
    },
    {
        title: '账号状态',
        scopedSlots: {
            customRender: 'state'
        },
        width: '120px',
        ellipsis: true
    },
    {
        dataIndex: 'mobile',
        title: '手机号',
        width: '120px',
        scopedSlots: {
            customRender: 'phoneNumber'
        }
    },
    {
        dataIndex: 'createdAt',
        title: '创建时间',
        width: '170px',
        scopedSlots: {
            customRender: 'createdAt'
        }
    },
    {
        title: '操作',
        //   dataIndex: 'operation',
        scopedSlots: {customRender: 'operation'},
        width: '264px',
        ellipsis: true
        // customCell: () => {
        //     return {
        //         style: {
        //             'min-width': '150px'
        //         }
        //     };
        // }
    }
];

const columnsStudent: any = [
    {
        dataIndex: 'serialNumber',
        title: '序号',
        width: '60px',
        scopedSlots: {
            customRender: 'serialNumber'
        }
    },
    {
        dataIndex: 'nickname',
        title: '姓名',
        width: '120px',
        ellipsis: true,
        scopedSlots: {
            customRender: 'nickname'
        }
    },
    {
        title: '性别',
        dataIndex: 'sex',
        width: '60px',
        customRender: (text: Number) => {
            if (text === 0) return '女';
            if (text === 1) return '男';
            return '未知';
        }
    },
    {
        dataIndex: 'username',
        title: '账号',
        width: '210px',
        scopedSlots: {
            customRender: 'studentAccount'
        }
    },
    {
        dataIndex: 'password',
        title: '密码',
        width: '125px',
        scopedSlots: {
            customRender: 'pwd'
        }
    },
    {
        dataIndex: '',
        title: '关联班级与课程',
        ellipsis: 'true',
        width: '130px',
        scopedSlots: {customRender: 'classAndCourse'}
    },
    {
        dataIndex: '',
        title: '账号状态',
        ellipsis: 'true',
        width: '120px',
        scopedSlots: {customRender: 'state'}
    },
    {
        title: '账号有效期',
        scopedSlots: {
            customRender: 'usefulLife'
        },
        width: '190px',
        ellipsis: true
    },
    {
        dataIndex: 'createdAt',
        title: '创建时间',
        width: '170px',
        scopedSlots: {
            customRender: 'createdAt'
        }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: '200px',
        scopedSlots: {customRender: 'operation'}
    }
];

const newTeacherForm: any = {
    _id: '',
    username: '',
    sex: undefined,
    nickname: '',
    attribute: 'external', //外部成员
    roles: ['teacher'], //角色为老师
    mobile: '',
    schoolId: '',
    password: '',
    isSchoolAdmin: false,
    validStartTime: '',
    expireTime: '',
    isDefaultExpire: true
};

const newStudentForm: any = {
    _id: '',
    username: '',
    sex: undefined,
    nickname: '',
    attribute: 'external', //外部成员
    roles: ['student'], //角色为学生
    schoolId: '',
    password: '',
    validStartTime: '',
    expireTime: '',
    isDefaultExpire: true
};

const checkData = function(rule: any, value: any, callback: any) {
    if (value) {
        if (!/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-9])\d{8}$/.test(value)) {
            callback(new Error('请输入正确的手机号!'));
        } else {
            callback();
        }
    }
    callback();
};
const checkNickName = function(rule: any, value: any, callback: any) {
    if (value) {
        if (!/[a-zA-Z0-9_\u4e00-\u9fa5- _.~!@#\$%\^&\*\(\)\+=\|\\\}\]\{\[:;<,>\?\/""]*/g.test(value)) {
            callback(new Error('仅支持中/英文、数字和下划线或其他符号'));
        } else {
            callback();
        }
    }
    callback();
};
const checkSpecial = function(rule: any, value: any, callback: any) {
    if (value) {
        if (!/^[0-9a-zA-Z_]{1,}$/g.test(value)) {
            callback(new Error('仅支持英文、数字和下划线'));
        } else {
            callback();
        }
    }
    callback();
};

// 密码输入框不支持中文的验证规则
const changeKey = function(rule: any, value: any, callback: any) {
    if (value === '') {
        callback();
    }
    //定义你需要的正则
    let rgx = /^(?!_)(?!.*?_$)[a-zA-Z0-9_]+$/;
    if (rgx.test(value)) {
        //验证通过调用回调函数
        callback();
    } else {
        callback(new Error('只允许包含数字、字母、下划线'));
    }
};
// 密码输入框不少于6位
const checkLength = function(rule: any, value: any, callback: any) {
    if (value === '') {
        callback();
    }
    if (value.length < 6) {
        callback(new Error('请输入不少于6位的密码'));
    }
    if (value.length > 30) {
        callback(new Error('最大长度30个字符'));
    } else {
        callback();
    }
};
const checkNumber = function(rule: any, value: any, callback: any) {
    if (value) {
        if (/^\d+$/g.test(value)) {
            callback(new Error(' 不可输入纯数字作为账号'));
        } else {
            callback();
        }
    }
    callback();
};

const formRulesTeacher: any = {
    username: [
        {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
        },
        {validator: checkNumber, trigger: 'blur'},
        {validator: checkSpecial, trigger: 'blur'},
        {max: 20, message: '最大长度20个字符', trigger: 'blur'}
    ],
    sex: [
        {
            required: true,
            message: '请选择性别',
            trigger: 'blur'
        }
    ],
    nickname: [
        {
            required: true,
            message: '请输入老师姓名',
            trigger: 'blur'
        },
        {validator: checkNickName, trigger: 'blur'},
        {max: 20, message: '最大长度20个字符', trigger: 'blur'}
    ],
    password: [
        {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
        },
        {validator: changeKey, trigger: 'blur'},
        {validator: checkLength, trigger: 'blur'}
    ],
    mobile: [
        {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
        },
        {
            min: 11,
            max: 11,
            message: '请输入11位手机号',
            trigger: 'blur'
        },
        {validator: checkData, trigger: 'blur'}
    ],
    validStartTime: [
        {
            required: true,
            message: '请选择有效期',
            trigger: 'change'
        }
    ]
};

const formRulesStudent: any = {
    username: [
        {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
        },
        {validator: checkNumber, trigger: 'blur'},
        {validator: checkSpecial, trigger: 'blur'},
        {max: 27, message: '最大长度27个字符', trigger: 'blur'}
    ],
    sex: [
        {
            required: true,
            message: '请选择性别',
            trigger: 'blur'
        }
    ],
    nickname: [
        {
            required: true,
            message: '请输入学生姓名',
            trigger: 'blur'
        },
        {validator: checkNickName, trigger: 'blur'},
        {max: 20, message: '最大长度20个字符', trigger: 'blur'}
    ],
    password: [
        {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
        },
        {validator: changeKey, trigger: 'blur'},
        {validator: checkLength, trigger: 'blur'}
    ],
    period: [
        {
            required: true,
            message: '请选择学段',
            trigger: 'change'
        }
    ],
    grade: [
        {
            required: true,
            message: '请选择年级',
            trigger: 'change'
        }
    ],
    classId: [
        {
            required: true,
            message: '请输入班级名称',
            trigger: 'change'
        }
    ],
    validStartTime: [
        {
            required: true,
            message: '请选择有效期',
            trigger: 'change'
        }
    ]
};

/**
 * 把本地页面data中定义的form转换接口所需的数据格式
 * @param {Object} pageForm
 */
const convertDbForm = function(pageForm: any) {
    let dbForm = {
        ...{},
        ...pageForm
    };
    return dbForm;
};

/**
 * 把通过查询返回的数据格式塞入到页面data的from属性中
 * @param {Object} dbFrom
 * @param {Object} contextForm
 */
const dbToForm = function(dbFrom: any, contextForm: any) {
    //赋值
    let newForm: any = {};

    for (let p in dbFrom) {
        newForm[p] = dbFrom[p];
    }
    return newForm;
};

export default {
    columns,
    columnsStudent,

    newTeacherForm,
    newStudentForm,

    // form,
    // editForm,
    copyNewForm: basicFormHelper.copyNewForm,

    formRulesTeacher,
    formRulesStudent,

    convertDbForm,
    dbToForm,

    allowUploadTypes: basicFormHelper.allowUploadTypes
};
